module.exports = __webpack_public_path__ + "assets/img/00002.c587d647.png";